import * as React from "react";
import { Query, graphql } from "react-apollo";
import { Row, Col, Button } from "reactstrap";
import * as uuid from "uuid";
import { MdModeEdit, MdDeleteForever } from "react-icons/md";

// GraphQL
import GetCompanyParts from "../../GraphQL/Queries/GetCompanyParts";
import DeletePart from "../../GraphQL/Mutations/DeletePart";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import Table from "../../Components/Table";
import GlobalModal from "../../Components/GlobalModal";
import DialogModal from "../../Components/DialogModal";

import EditPartForm from "./EditPartForm";

interface IProps {
  companyId: string;
  toastManager: any;
  mutate: any;
}

class AllParts extends React.Component<IProps> {
  state = {
    modal: false,
    dialogModal: false,
    loading: false,
    title: "Are you sure you want to delete this part?",
    part: {},
    partId: null
  };

  // Close dialog modal
  closeDialogModal = (): void => {
    this.setState({
      dialogModal: false
    });
  };

  // Open dialog modal
  openDialogModal = (companyPart: any): void => {
    const partId = !companyPart ? null : companyPart.id;
    this.setState({
      dialogModal: true,
      partId
    });
  };

  // Handle response
  handleResponse = (e: React.FormEvent<HTMLInputElement>): void => {
    e.preventDefault();
    this.setState({ loading: true });
    // delete site mutation
    const { companyId } = this.props;
    this.props
      .mutate({
        variables: {
          id: this.state.partId
        },
        refetchQueries: [
          {
            query: GetCompanyParts,
            variables: { id: companyId }
          }
        ]
      })
      .then((res: any) => {
        this.setState({ loading: false, partId: null });
        this.closeDialogModal();
        this.toastNotification("Part deleted successfully");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (part: object): void => {
    this.setState({
      modal: true,
      part
    });
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    const { part } = this.state;
    const { companyId } = this.props;
    return (
      <Query query={GetCompanyParts} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the parts</div>;
          }

          const parts = data.allParts;

          return (
            <Row>
              <GlobalModal
                toggleModal={this.closeModal}
                title="Edit Part"
                modalDisplay={
                  <EditPartForm
                    notification={this.toastNotification}
                    closeModal={this.closeModal}
                    companyId={companyId}
                    part={part}
                  />
                }
                modal={this.state.modal}
              />
              <DialogModal
                modal={this.state.dialogModal}
                title={this.state.title}
                loading={this.state.loading}
                toggleModal={this.closeDialogModal}
                handleResponse={this.handleResponse}
              />
              <Col xs={12} md={12} lg={12}>
                <Table
                  data={parts}
                  columns={[
                    {
                      Header: "Name",
                      accessor: "name",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Description",
                      accessor: "description",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Category",
                      accessor: "category",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Bar Code",
                      accessor: "barcode",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Site",
                      accessor: (companyPart: any) => {
                        return !companyPart.site ? "" : companyPart.site.name;
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyPart: object) => {
                        return (
                          <Button
                            onClick={() => this.openModal(companyPart)}
                            className="icon-btn icon-edit-btn"
                          >
                            <MdModeEdit color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyPart: object) => {
                        return (
                          <Button
                            onClick={() => this.openDialogModal(companyPart)}
                            className="icon-btn icon-delete-btn"
                          >
                            <MdDeleteForever color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={5}
                  showPaginationTop={false}
                  showPaginationBottom={true}
                />
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default graphql<any, Response, any, any>(DeletePart)(AllParts);



// WEBPACK FOOTER //
// ./src/Containers/Parts/AllParts.tsx